import React, { Component } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import {
  HamburgerIcon,
  ChevronDownIcon,
  LinkIcon,
  CalendarIcon,
} from "@chakra-ui/icons";
import Timeline from "react-calendar-timeline";
import "react-calendar-timeline/lib/Timeline.css";
import moment from "moment";
import axios from "axios";
import DatePicker from "react-datepicker";
import Calendar2 from "../objCalTest2";

import "react-datepicker/dist/react-datepicker.css";
import * as objs from "../../objs";
import Testing from "./TestingTimeLine";

const visibleTimeStart = moment().startOf("day").valueOf();
const visibleTimeEnd = moment().startOf("day").add(5, "hour").valueOf();

var items = [
  {
    id: "916",
    group: "14",
    title:
      "I'll back up the back-end GB interface, that should interface the COM driver!",
    start: visibleTimeStart,
    end: visibleTimeEnd,
    className: "",
    itemProps: {
      "data-tip":
        "backing up the panel won't do anything, we need to input the auxiliary THX firewall!",
    },
  },
];

var keys = {
  groupIdKey: "id",
  groupTitleKey: "title",
  groupRightTitleKey: "rightTitle",
  itemIdKey: "id",
  itemTitleKey: "title",
  itemDivTitleKey: "title",
  itemGroupKey: "group",
  itemTimeStartKey: "start",
  itemTimeEndKey: "end",
  groupLabelKey: "title",
};
var groups = [
  {
    id: "14",
    title: "Maymie",
    rightTitle: "Satterfield",
    bgColor: "#6ebbe5",
  },
];
var campusId = "7";
var campusName = "Hallam";
var startDate = new Date();
class Planner extends Component {
  state = {
    groups: [
      {
        id: "1",
        title: <Button>bob</Button>,
        rightTitle: "Kautzer",
        bgColor: "#a4f9f2",
      },
    ],
    lstgetTrainers: [],
    isOpen: false,
    selectedTitle: "",
    selectedFirstname: "",
    selectedLastname: "",
  };
  constructor(props) {
    super(props);
    const visibleTimeStart = moment().startOf("day").valueOf();
    const visibleTimeEnd = moment().startOf("day").add(1, "day").valueOf();

    this.state = {
      items,
      visibleTimeStart,
      visibleTimeEnd,
    };
  }
  componentDidMount() {
    this.addMoreListeners();
    this.loadTrainers();
  }

  getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }

  async showTrainerTimetable(data) {
    var name = data.split(" ");
    var fn = name[0];
    var ln = "";
    for (var i = 1; i <= name.length - 1; i++) {
      ln += name[i] + " ";
    }

    ln = ln.trim();
    console.log(fn, ln);
    this.setState({
      isOpen: true,
      selectedTitle: data,
      selectedFirstname: fn,
      selectedLastname: ln,
    });
  }

  async addMoreListeners() {
    this.props.chatSocket.on("getTrainers", (data) => {
      var j = JSON.parse(data);
      this.setState({ lstgetTrainers: j });

      //this.forceUpdate();
    });

    this.props.chatSocket.on("getTrainersTime", (data) => {
      var j = JSON.parse(data);
      var d2 = j;
      var tmpItems = [];

      for (var s in d2) {
        var resource_id = d2[s]["resource_id"];
        var session_date = d2[s]["session_date"];
        var session_state_time = d2[s]["session_start_time"];
        var session_duration = d2[s]["session_duration"];
        var program_tdt_short_name = d2[s]["program_tdt_short_name"];

        var timestring2 = session_date + "T" + session_state_time + "Z";
        var travelTime = moment(timestring2).subtract(11, "hour");

        const startValue = Math.floor(travelTime.valueOf());
        const endValue = Math.floor(
          travelTime.add(session_duration, "hour").valueOf()
        );

        var showTime = moment(timestring2)
          .subtract(11, "hour")
          .format("h:mm a");

        tmpItems.push({
          id: s,
          group: resource_id,
          title: program_tdt_short_name,
          start: startValue,
          end: endValue,
          className: "",

          itemProps: {
            "data-tip":
              "The SSL monitor is down, reboot the open-source port so we can compress the PNG circuit!",
            onMouseDown: () => {
              alert("show intake " + JSON.stringify(d2[s]));
            },
          },
        });
      }

      items = tmpItems;

      this.forceUpdate();
    });
  }

  async getData(link) {
    const res = await axios.get(link);
    return res["data"];
  }

  async loadTrainers() {
    this.props.chatSocket.emit(
      "getTrainers",
      JSON.stringify({ campusId: campusId })
    );

    var getM = this.getMonday(new Date(startDate));
    var todayDate = getM.toISOString().slice(0, 10);

    this.props.chatSocket.emit(
      "getTrainersTime",
      JSON.stringify({ campusId: campusId, start_date: todayDate })
    );
  }

  onPrevClick = () => {
    const zoom = this.state.visibleTimeEnd - this.state.visibleTimeStart;
    this.setState((state) => ({
      visibleTimeStart: state.visibleTimeStart - zoom,
      visibleTimeEnd: state.visibleTimeEnd - zoom,
    }));
  };

  onNextClick = () => {
    const zoom = this.state.visibleTimeEnd - this.state.visibleTimeStart;
    this.setState((state) => ({
      visibleTimeStart: state.visibleTimeStart + zoom,
      visibleTimeEnd: state.visibleTimeEnd + zoom,
    }));
  };

  setStartDate(date) {
    var loadNewDate = new Date(date);

    startDate = loadNewDate;
    const visibleTimeStart = moment(loadNewDate).startOf("day").valueOf();
    const visibleTimeEnd = moment(loadNewDate)
      .startOf("day")
      .add(1, "day")
      .valueOf();

    this.setState({
      visibleTimeStart: visibleTimeStart,
      visibleTimeEnd: visibleTimeEnd,
    });
    this.loadTrainers();
  }

  changeCampus(id, name) {
    campusId = id;
    campusName = name;
    this.loadTrainers();
  }

  //onClick={() => this.btnPressMenu(1)}
  render() {
    const {
      visibleTimeStart,
      visibleTimeEnd,
      startDate,
      lstgetTrainers,
      isOpen,
      selectedTitle,
      selectedFirstname,
      selectedLastname,
    } = this.state;

    var tmplst = [];
    var data = lstgetTrainers;
    for (var n in data) {
      const ttt = data[n]["resource_full_name"];
      tmplst.push({
        id: data[n]["resource_id"],
        title: (
          <Button onClick={() => this.showTrainerTimetable(ttt)}>
            {data[n]["resource_full_name"]}
          </Button>
        ),
        rightTitle: "Kautzer",
        bgColor: "#a4f9f2",
      });
    }

    /*var lstBtnTrainers = data.map((userData) => (
        <div key={uuidv4()}>

        </div>
      ));*/
    //console.log(tmplst);
    //groups = tmplst;
    var showCal = <></>;
    if (selectedFirstname != "") {
      showCal = (
        <Calendar2
          firstname={selectedFirstname}
          lastname={selectedLastname}
          chatSocket={this.props.chatSocket}
          /*reqTrainerData={this.btnTrainers}
trainerTimeTable={trainerTimeTable}
trainerStudentse={trainerStudentse}
allocatedResource={allocatedResource}*/
        />
      );
    }

    return (
      <Center>
        <Drawer placement="top" isOpen={isOpen} size="full">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader>
              <Button onClick={() => this.setState({ isOpen: false })}>
                Back
              </Button>{" "}
              {selectedTitle}
            </DrawerHeader>
            <DrawerBody>{showCal}</DrawerBody>
          </DrawerContent>
        </Drawer>
        <Stack w="100%">
          <Wrap>
            <WrapItem>
              <Menu>
                <MenuButton
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                  colorScheme="teal"
                >
                  {campusName}
                </MenuButton>
                <MenuList>
                  <MenuItem onClick={() => this.changeCampus(7, "Hallam")}>
                    Hallam
                  </MenuItem>
                  <MenuItem onClick={() => this.changeCampus(1, "Dandenong")}>
                    Dandenong
                  </MenuItem>
                  <MenuItem
                    onClick={() => this.changeCampus(2, "Carrum Downs")}
                  >
                    Carrum Downs
                  </MenuItem>
                  <MenuItem onClick={() => this.changeCampus(3, "Bendigo")}>
                    Bendigo
                  </MenuItem>
                  <MenuItem onClick={() => this.changeCampus(4, "Sale")}>
                    Sale
                  </MenuItem>
                  <MenuItem onClick={() => this.changeCampus(5, "Offsite")}>
                    Offsite
                  </MenuItem>
                  <MenuItem onClick={() => this.changeCampus(6, "Sunshine")}>
                    Sunshine
                  </MenuItem>
                  <MenuItem onClick={() => this.changeCampus(8, "Ridetek")}>
                    Ridetek
                  </MenuItem>
                  <MenuItem onClick={() => this.changeCampus(9, "Ballarat")}>
                    Ballarat
                  </MenuItem>
                </MenuList>
              </Menu>
            </WrapItem>
            ,
            <WrapItem>
              <Button colorScheme="teal" onClick={this.onPrevClick}>
                {"< Prev"}
              </Button>
            </WrapItem>
            <WrapItem>
              <Button colorScheme="teal" onClick={this.onNextClick}>
                {"Next >"}
              </Button>
            </WrapItem>
            <WrapItem>
              <DatePicker
                selected={startDate}
                onChange={(date) => this.setStartDate(date)}
              />
            </WrapItem>
          </Wrap>
          <Box w="100%" h="100%">
            <Timeline
              scrollRef={(el) => (this.scrollRef = el)}
              groups={tmplst}
              items={items}
              keys={keys}
              itemTouchSendsClick={false}
              stackItems
              itemHeightRatio={0.75}
              showCursorLine
              canMove={false}
              canResize={false}
              visibleTimeStart={visibleTimeStart}
              visibleTimeEnd={visibleTimeEnd}
            />
          </Box>
        </Stack>
      </Center>
    );
  }
}

export default Planner;
